import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import { dispError } from "../../utils/Tools";

import ErrorLine from "../elements/ErrorLine";

function FormLogin(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();

  const validation = Yup.object({
    email: Yup.string().email("Keine gültige E-Mail-Adresse").required("Bitte geben Sie eine E-Mail-Adresse ein."),
    pwd: Yup.string().min(8, "Das Passwort muss mind. 8 Zeichen lang sein.").required("Bitte geben Sie ein Passwort ein.")
  });

  const initialValues = { email: "", pwd: "" };
  const targetURL = "/user/auth";

  const onSubmit = (values, { setSubmitting }) => {
    let payload = { ...values };
    // console.log(`onSubmit, ${targetURL}:`, JSON.stringify(payload));
    DataFetcher.fetch(targetURL, payload)
      .then(response => {
        if (!response.success) {
          setSubmitting(false);
          return appDispatch(dispError(response.msg));
        }
        appDispatch({ type: "login", data: response.user });
        history.push("/");
      })
      .catch(error => {
        console.error(error);
        setSubmitting(false);
      });
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="field">
            <p className="control has-icons-left has-icons-right">
              <Field name="email" type="email" placeholder="E-Mail-Adresse" className={`input${touched.email && errors.email ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
              <span className="icon is-small is-right is-success">
                <i className="fas fa-check"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="email" />
          </div>
          <div className="field">
            <p className="control has-icons-left">
              <Field name="pwd" type="password" placeholder="Passwort" className={`input${touched.pwd && errors.pwd ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-lock"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="pwd" />
          </div>
          <div className="field">
            <p className="control">
              <button className="button is-success" type="submit" disabled={isSubmitting}>
                Login
              </button>
            </p>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default FormLogin;
